declare global {
  interface Window {
    __ferriviaBootWatchdog?: ReturnType<typeof setTimeout>;
  }
}

export type BootReadyReason = "app" | "login" | "onboarding" | "enrolment" | "error" | "timeout";

let dismissed = false;

/**
 * Idempotent: the gate chain can race (StrictMode's mount->unmount->mount,
 * or the inline watchdog firing the same frame a gate resolves), and only
 * the first call may act — a second `leaving` / removal would restart the
 * fade or double-remove the node.
 */
export function markBootReady(reason: BootReadyReason): void {
  if (dismissed) return;
  dismissed = true;

  if (window.__ferriviaBootWatchdog !== undefined) {
    clearTimeout(window.__ferriviaBootWatchdog);
  }

  const root = document.documentElement;
  root.dataset.bootDismissedBy = reason;

  const splash = document.getElementById("boot-splash");
  if (!splash) return;

  splash.classList.add("leaving");

  let removed = false;
  function remove() {
    if (removed) return;
    removed = true;
    splash?.remove();
  }

  // transitionend does not fire under prefers-reduced-motion (no transition
  // runs) or reliably in a backgrounded tab, so a fallback timer is what
  // actually guarantees removal.
  splash.addEventListener("transitionend", remove, { once: true });
  setTimeout(remove, 500);
}
